export const en = {
    'accept-button': 'Raise',
    'many-days-title-hint':
        'The recommendation is shown because over the last {daysNumber} days the campaigns stopped due to daily budget limitations and lost effective clicks',
    'one-day-title-hint':
        'The recommendation is shown because over the last day the campaigns stopped due to daily budget limitations and lost effective clicks',
    'simple-progress-hint': 'Raising the budget limit',
    'simple-title': 'Повысьте ограничение бюджета до {sum}',
    'some-days-title-hint':
        'The recommendation is shown because over the last {daysNumber} days the campaigns stopped due to daily budget limitations and lost effective clicks'
};
